import { RoomId, roomId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomBrandCaptionLowerThirdDeleteEventVO {
  private static validation = JsonSchemaValidator.compile(
    RoomBrandCaptionLowerThirdDeleteEventVO.validationSchema()
  );

  constructor(readonly value: RoomBrandCaptionLowerThirdDeleteEvent) {
    JsonSchemaValidator.assert(
      RoomBrandCaptionLowerThirdDeleteEventVO.validation,
      value
    );
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId"],
      properties: {
        roomId
      },
      additionalProperties: false
    };
  }
}

interface RoomBrandCaptionLowerThirdDeleteEvent {
  roomId: RoomId;
}
